import { request } from "./client";
import USE_MOCK from "../mock/config";
import { mockFetchTenantAuditLogs } from "../mock/mockHandlers";

export const fetchTenantAuditLogs = (tenantId) =>
  USE_MOCK ? mockFetchTenantAuditLogs(tenantId) : request(`/bots/${tenantId}/audit-logs`);

export const fetchAuditLogs = (params = {}) =>
  request("/audit-logs", { params });
